class ToolboxToolsAjax {
  constructor() {
    this.$body = $('body')
    this.scopeRole = {
      toolboxWidget: '.toolbox-widget',
      button: '.toolbox-widget__button',
      mediateurField: 'input:radio[name="_mediator"]',
      thematiqueField: 'input:checkbox[name="_toolbox_thematiques"]',
    }
    this.ajaxMethod = {
      putAction: 'query_toolbox_tools',
    }

    this.data = {
      action: this.ajaxMethod.putAction,
      // eslint-disable-next-line no-undef
      security: ajax_object.ajax_nonce,
      mediateur: '',
      thematiques: [],
    }

    if(this.$body.hasClass('template-approfondir') && this.$body.find(this.scopeRole.toolboxWidget).length) {
      this.init()
    }
  }

  init() {
    const $toolboxWidget = this.$body.find(this.scopeRole.toolboxWidget)

    $(this.scopeRole.mediateurField).change((evt) => {
      const $el = $(evt.currentTarget)
      console.log($el.val())
      console.log($toolboxWidget.data('term'))
      if ($el.val() === $toolboxWidget.data('term')) {
        this.data.mediateur = $el.val()
      } else {
        this.data.mediateur = ''
      }
      this.ajaxRequest(this.data)
    })

    $(this.scopeRole.thematiquesField).change(() => {
      let thematiquesArray = []
      const $thematiqueChecked = $(`${this.scopeRole.thematiquesField}:checked`)
      if($thematiqueChecked.length) {
        $(`${this.scopeRole.thematiquesField}:checked`).each((_, el) => {
          const $el = $(el)
          thematiquesArray.push($el.val())
        })
      }
      this.data.thematiques = thematiquesArray
      this.ajaxRequest(this.data)
    })
  }

  ajaxRequest(data) {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      this.$body.find(this.scopeRole.button).find('span').html(`(${data.count})`)
    })
  }
}

export default ToolboxToolsAjax;



// WEBPACK FOOTER //
// ./scripts/components/ToolboxToolsAjax.js